import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { objectTitleAtom } from '@frontend/atoms';

const PAGE_TITLES: Record<string, string> = {
  chat: 'Chat',
  instructions: 'Instructions',
  agents: 'Agents',
  tools: 'Tools',
  rag: 'RAG',
  connections: 'Connections',
  settings: 'Settings',
};

const MAX_TITLE_LENGTH = 30;

const truncateTitle = (title: string, maxLength: number = MAX_TITLE_LENGTH): string => {
  if (title.length <= maxLength) {
    return title;
  }
  return `${title.slice(0, maxLength).trim()}...`;
};

export const useRouteDocumentTitle = () => {
  const location = useLocation();
  const objectTitle = useAtomValue(objectTitleAtom);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const section = pathParts[3];
    const pageTitle = PAGE_TITLES[section];

    if (pageTitle && objectTitle) {
      const truncatedObjectTitle = truncateTitle(objectTitle);
      document.title = `${pageTitle} • ${truncatedObjectTitle} | Opal`;
    } else if (pageTitle) {
      document.title = `${pageTitle} | Opal`;
    } else {
      document.title = 'Opal';
    }
  }, [location.pathname, objectTitle]);
};

export const useObjectTitle = (title: string | null | undefined) => {
  const setObjectTitle = useSetAtom(objectTitleAtom);

  useEffect(() => {
    if (title) {
      setObjectTitle(title);
    }
    return () => setObjectTitle(null);
  }, [title, setObjectTitle]);
};
